<template>
  <footer
    v-if="appVersionLabel && shouldShowFooter"
    class="app-footer"
    aria-label="Versao do aplicativo"
  >
    <div class="app-footer__inner">
      <span class="app-footer__label">AOL 2.0</span>
      <span
        class="app-footer__divider"
        aria-hidden="true"
      >
        |
      </span>
      <span class="app-footer__version">{{ appVersionLabel }}</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      shouldShowFooter: true,
    }
  },
  computed: {
    appVersionLabel() {
      const version = process.env.APP_VERSION
      return version ? 'v' + version : ''
    },
  },
  mounted() {
    this.updateFooterVisibility()
    window.addEventListener('scroll', this.updateFooterVisibility, { passive: true })
    window.addEventListener('resize', this.updateFooterVisibility)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateFooterVisibility)
    window.removeEventListener('resize', this.updateFooterVisibility)
  },
  methods: {
    updateFooterVisibility() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0
      const viewportHeight = window.innerHeight || 0
      const docHeight = Math.max(
        document.documentElement.scrollHeight || 0,
        document.body.scrollHeight || 0
      )
      const remaining = docHeight - (scrollTop + viewportHeight)
      const hasScroll = docHeight > viewportHeight + 1
      this.shouldShowFooter = !hasScroll || remaining > 30
    },
  },
}
</script>

<style lang="scss">
.app-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #7f1a54;
  box-shadow: 0 -6px 18px rgba(0, 0, 0, 0.12);
  color: #fff;
  font-family: 'Exo 2', sans-serif;
}

.app-footer__inner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 16px;
  font-size: 12px;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.app-footer__label {
  font-weight: 600;
}

.app-footer__divider {
  opacity: 0.6;
}

.app-footer__version {
  font-weight: 700;
}

@media screen and (max-width: 767px) {
  .app-footer {
    height: 36px;
  }

  .app-footer__inner {
    font-size: 11px;
    letter-spacing: 0.8px;
  }
}
</style>
